<template>
    <div class='banner-view'>
        <div v-if="lang==1">
          <img :src="login_zh">
        </div>
        <div v-if="lang==2">
          <img :src="login_en">
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
	data () {
		return {
			login_zh: 'https://infosalons.oss-cn-shanghai.aliyuncs.com/vscenter/uploads/images/cbme2020/banner_zh.jpg',
			login_en: 'https://infosalons.oss-cn-shanghai.aliyuncs.com/vscenter/uploads/images/2019/cbme2019_banner_en.jpg'
		}
	},
  computed:{
    ...mapState(['lang'])
  }
}
</script>
<style scoped>
    .banner-view {
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .banner-view img {
        display: block;
        width: 100%;
        height: auto;
        max-height: 360px;
    }
</style>



// WEBPACK FOOTER //
// src/base/Banner.vue